
import { GameState } from '../GameContextTypes';

export const updateKpi = (state: GameState, kpiName: string, value: number): GameState => {
  const updatedKpis = { ...state.kpis };
  // @ts-ignore - we know kpiName is a valid key
  updatedKpis[kpiName] = Number(parseFloat(updatedKpis[kpiName] + value).toFixed(3));
  
  return {
    ...state,
    kpis: updatedKpis
  };
};
